
"use client";

import type { ThemeProviderProps } from "next-themes";

import * as React from "react";
import { HeroUIProvider } from "@heroui/system";
import { useRouter } from "next/navigation";
import { useRef } from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";
import { constants } from "buffer";
import {LcgContextProvider } from "@/config/context-conn";


export interface ProvidersProps {
  children: React.ReactNode;
  themeProps?: ThemeProviderProps;
}

declare module "@react-types/shared" {
  interface RouterConfig {
    routerOptions: NonNullable<
      Parameters<ReturnType<typeof useRouter>["push"]>[1]
    >;
  }
}
export function Providers({children}: {children: React.ReactNode}) {
  const router = useRouter();

  return (
    <LcgContextProvider>
      <HeroUIProvider
        navigate={(href) => router.push(href)}
        locale="cs-CZ"
      >
          {children}
      </HeroUIProvider>
    </LcgContextProvider>
  );
}
